import * as React from "react";

const FlutterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 32 32"
  >
    <path
      fill="#40d0fd"
      d="m15.383 18.316 3.361-3.274h8.349l-7.396 7.396z"
    ></path>
    <path
      fill="#41d0fd"
      d="m4.907 16.125 4.199 4.299L27.093 2.287h-8.349z"
    ></path>
    <path
      fill="#1fbcfd"
      d="m11.176 22.479 4.259 4.196 4.262-4.237-4.314-4.122z"
    ></path>
    <path
      fill="#095a9d"
      d="m15.435 26.675 4.262-4.237 7.292 7.375h-8.396z"
    ></path>
    <path fill="#0e5199" d="m15.435 26.675 3.971-1.321-1.338-1.297z"></path>
  </svg>
);

export default FlutterIcon;
